//Registro de Aspirante
export const CARACTERES_INVALIDOS = "Caracteres no permitidos";
export const FORMATO_INVALIDO = "Formato inválido";
export const FORMATO_PASS = "No cumple con las especificaciones.";
export const REQUERIDO = "Este campo es obligatorio";
export const EDAD_NACIMIENTO = "Tienes que ser mayor de 18 años";
export const SELECCIONA_OPCION = "Selecciona una opción";
export const CORREO_CONFIRMA = "Por favor confirma tu correo electrónico.";
export const PASS_CONFIRMA = "Por favor confirma tu contraseña.";
export const CORREO_CONFIRMA_ERROR = "El correo electrónico no coincide.";
export const PASS_CONFIRMA_ERROR = "La contraseña no coincide.";
export const CODIGO_POSTAL = "Código postal inválido";
export const INFO_ASPIRANTE = `¡Importante! La actualización del TIPO DE ASPIRANTE podrá realizarse cuando te postules a un cargo o puesto.`;
export const INFO_CORREO =
  "Asegúrate de que tu correo y contraseña sean correctos.";
export const INFO_NOMBRES = "Alguno de los apellidos es necesario.";
export const INFO_TEL =
  "Es necesario que proporciones dos números de teléfono en los que podamos contactarte fácilmente.";
export const INFO_TEL_10 = "(10 dígitos)";
export const INFO_APELLIDOS =
  "Es necesario ingresar al menos uno de los apellidos.";
export const INFO_REV_1 =
  "Una vez postulado a una vacante, tu registro quedará guardado y no podrás modificar tus datos.";
export const INFO_REV_2 =
  "Los datos que captures en este registro ya no podrán editarse posteriormente al postularte para alguna vacante.";
export const INFO_REGISTRAR =
  "Verifica que los datos registrados en cada campo sean los correctos.";

export const INFO_ELIMINAR = "¿Estás seguro de eliminar?";
export const INFO_PASSWORD = "Restablece la contraseña";
export const INFO_ARCHIVO =
  "El documento debe de ser en formato PDF, máximo 5MB y debe de ser legible.";
export const INFO_FECHA_NAC =
  "¡Atención!. Estas realizando un cambio a tu fecha de nacimiento que es asignada de acuerdo a tu curp.";
export const INFO_ESTADO_NAC =
  "¡Atención!. Estas realizando un cambio a tu estado de nacimiento que es asignada de acuerdo a tu curp.";
export const INFO_SEXO =
  "¡Atención!. Estas realizando un cambio de tu sexo que es asignada de acuerdo a tu curp.";
export const INFO_SEXO_CLAVE =
  "Elige el sexo que se muestra en tu documentación e indentificaciones oficiales.";
export const INFO_WARNING =
  "¡Atención! El dato que registraste no coincide con la información del curp.";

//Datos del Aspirante - inicio de sesión
export const TAB_REQ_ACADEMICO =
  "Permanece en la sección de Información académica para agregar más niveles de estudio si lo requieres. De no ser así continúa con la sección de Experiencia laboral.";
export const TAB_EXP_LABORAL =
  "Permanece en la sección de Experiencia laboral para agregar más si lo requieres. De no ser así continúa con la selección del Tipo de aspirante y protesto.";
export const TAB_TIPO_ASP =
  "Permanece en el módulo de Datos personales para revisar la información capturada. De no ser así continúa en el módulo de Convocatorias para revisar las vacantes disponibles para postulación.";
export const INFO_REGISTRO = "Te registraste exitosamente.";
export const INFO_REGISTRO_MODAL =
  "Para realizar la postulación a un cargo es necesario realizar el registro de la información complementaria.";
export const INFO_UPD_PASSWORD =
  "Para realizar la postulación a un cargo o puesto es necesario que revises tu registro y, de ser el caso, concluir con la captura de tu información";
export const INFO_POSTULACION =
  "Revisa que tu información sea la correcta. Una vez hecha la postulación, ya no podrá modificarse.";

//Consulta Vacantes Login
export const INFO_VACANTE_1 = "Para postularte es necesario";
export const INFO_VACANTE_2 = "iniciar sesión o";
export const INFO_VACANTE_EXAM =
  "Selecciona la entidad donde desarrollarás las etapas presenciales del concurso.";

export const REQ_ACADEMICO =
  "Al menos debe agregar una información de escolaridad";
export const REQ_FECHA =
  "La fecha ingresada no debe de ser mayor a la fecha actual.";
export const REQ_LIMITE = "Al menos debe de tener un requisito académico.";

//Expediente Digital
export const EXP_ARCHIVO =
  "Agrega un archivo PDF para cada uno de los documentos solicitados y asegurate de que su contenido es legible.";
export const DOCUMENTOS_EXP = "Se concluyó con la carga del expedienté digital.";
export const DOCUMENTOS_EXP_INFO = "Estimado aspirante, no ha concluido la carga de su expediente digital.";

export const SESION = "Su sesión esta a punto de expirar, ¿Desea continuar?";
//Errors
export const ERROR = "¡Ocurrió una acción inesperada!";
export const ERROR_EXPEDIENTE = "Por el momento no se puede capturar el expediente.";
export const ERROR_FECHA_FIN =
  "La fecha fin no puede ser menor a la fecha de inicio.";
export const ERROR_ARCHIVO = "El archivo no se encuentra disponible.";
export const ERROR_INTERNET =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_MENU =
  "¡Ocurrió una acción inesperada!, al recuperar el menú, por favor actualice la página";
export const ERROR_VACANTE =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_CONCURSOS =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_CONVOCATORIA =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_FUNCIONES =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_OBJETIVOS =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";
export const ERROR_REQUISITOS =
  "¡Ocurrió una acción inesperada!, revise su conexión a internet";

export const MALA_ACCION =
  "Ocurrió una acción inesperada al procesar la información.";
